import { Carousel, Image } from "react-bootstrap";

// Import images from the folder
import image1 from "../assets/carousel/image1.webp";
import image2 from "../assets/carousel/image2.webp";
import image3 from "../assets/carousel/image3.webp";

const images = [
  { src: image1, alt: "Image1", name: "Image1", text: "הנאה" },
  { src: image2, alt: "Image2", name: "Image2", text: "גיבוש" },
  { src: image3, alt: "Image3", name: "Image3", text: "אסטרטגיה" },
];

const ProductCarousel = () => {
  return (
    <Carousel pause="hover" className="bg-primary mb-4">
      {images.map((image, index) => (
        <Carousel.Item key={index}>
          <Image
            src={image.src}
            alt={image.alt}
            fluid
            style={{ width: "100%", height: "40vw", maxHeight: "500px", objectFit: "cover" }}
          />
          <Carousel.Caption className="carousel-caption" style={{ background: "transparent" }}>
            <div className="carousel-caption__div" style={{ background: "transparent" }}>
              <h2>{image.text}</h2>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ProductCarousel;
